
import IDKITApi from '../libs/IDKITApi';

export default {
  name: 'LoginClient',
  data: () => ({
    isError: false,
    email: '',
    state: '',
  }),
  computed: {
    mobile() {
      return this.$q.screen.lt.md;
    },
  },
  async mounted() {
    // El punto de entrada tomamos el email y
    // el state de la sesión, si no hay van vacíos para retornar a IDKIT
    this.email = this.$session.get('email') || null;
    this.state = this.$session.get('state') || null;
    // De un inicio eliminamos las sesiones existentes
    // para sobreescribirlas en dado caso que cambien de id de orden
    if ('superOrderId' in localStorage) {
      this.$session.destroy();
      localStorage.removeItem('superOrderId');
    }
    if ('isInternal' in localStorage) localStorage.removeItem('isInternal');
    // Seteamos la orden en sesión para cargar posteriormente sus datos

    this.saveSuperorderInSession();

    localStorage.setItem('isInternal', '0');
    try {
      /*
      Obtenemos la data de IDKIT si es que ya existe
      la sesión (con los datos anteriores de email y state obtenidos de la sesion)
      entonces solo redireccionamos al auth con el email
      y el state de lo contrario entra al catch y va a IDKIT
      */
      this.$router.push({ name: 'Init' });
    } catch (err) {
      if (!err.headers?.location) this.isError = true;
      else window.location.href = err.headers.location;
    }
  },
  methods: {
    saveSuperorderInSession() {
      const superorder = this.$route.query.orderid ?? this.$route.query.orderId;
      localStorage.setItem('superOrderId', superorder);
      this.$session.set('superOrderId', superorder);
    },
    getIDKitData() {
      return IDKITApi.validateUserSession(this.email, this.state, this.orderId)
        .then((res) => {
          if (!res.data.access_token) throw res;
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
